<mat-card-content
  *ngIf="isLoading"
  class="d-flex flex-col flex-wrap align-items-center justify-content-center"
  style="padding-bottom: 36px"
>
  <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
  <p>Cargando Insumos de la actividad...</p>
</mat-card-content>

<mat-dialog-content
  [style.display]="isLoading ? 'none' : 'flex'"
  class="row-base gap-30 div-center"
  style="height: fit-content; padding: 0px 30px"
>
  <h2
    style="font-weight: 600; font-size: 24px; line-height: 32px; color: #111827"
    mat-dialog-title
  >
    Insumos -
    <span style="color: #e95a1a">
      <ng-container *ngIf="dialogData.EDIT_FILE_OUTFLOWS">
        {{ dialogData.EDIT_FILE_OUTFLOWS.currentService?.nombreServicio ?? '' }}
      </ng-container>
      <ng-container *ngIf="dialogData.EDIT_ADDITIONAL_OUTFLOWS">
        Egreso Adicional -
        {{
          dialogData.EDIT_ADDITIONAL_OUTFLOWS.additionalOutflow.observation ??
            ''
        }}
      </ng-container>
      <ng-container *ngIf="dialogData.CREATE_ADDITIONAL_OUTFLOWS">
        Registrar un Egreso de tipo Adicional
      </ng-container>
    </span>
  </h2>

  <div class="row-base gap-30 div-center">
    <form [formGroup]="newInsumoForm" style="min-width: 100%">
      <div
        id="card-table-AS"
        class="column-base"
        [ngClass]="{
          active: openMoreInformation,
          'gap-20': openMoreInformation
        }"
      >
        <div class="row-base vertical-center title-AS-card-Cont">
          <div class="title-AS-card f-w-600 f-s-14">Añadir Insumos</div>
          <mat-icon
            style="cursor: pointer"
            (click)="handleInformation(!openMoreInformation)"
          >
            <i-tabler
              name="circle-chevron-up"
              class="icon-20 d-flex"
            ></i-tabler>
          </mat-icon>
        </div>
        <div *ngIf="openMoreInformation" class="line"></div>
        <div
          class="insumoForm-cont"
          style="max-width: 100%; min-width: 100%; overflow-x: auto"
        >
          <div class="row-base" style="min-width: 100%">
            <div class="col-sm-4 w-100">
              <mat-label class="label">Insumo (SKU)</mat-label>
              <mat-form-field appearance="outline" class="w-100 hide-hint">
                <input
                  type="text"
                  placeholder="Elige un Insumo del Almacén"
                  matInput
                  [formControl]="inputInsumoControl"
                  [matAutocomplete]="auto"
                />
                <mat-autocomplete
                  #auto="matAutocomplete"
                  [displayWith]="getOptionText"
                  (optionSelected)="updateUnidadMedida($event)"
                >
                  <mat-option
                    disabled
                    *ngIf="
                      (filteredOptionsWithValidation$ | async)?.length === 0
                    "
                  >
                    No se encontraron insumos (SKUs)
                  </mat-option>
                  <mat-option
                    *ngFor="let item of filteredOptionsWithValidation$ | async"
                    [value]="item.option"
                    [disabled]="item.isDuplicate"
                  >
                    <div *ngIf="!item.isDuplicate">
                      <span
                        style="
                          font-size: 12px;
                          white-space: nowrap;
                          overflow: hidden;
                          text-overflow: ellipsis;
                          max-width: 100%;
                        "
                      >
                        STOCK: {{ item.option.stock | number: '1.2-2' }}
                        {{ item.option.unidadMedida }} -
                        <span style="font-weight: 500">{{
                          item.option.nombreInsumo
                        }}</span>
                      </span>
                    </div>
                    <div *ngIf="item.isDuplicate" style="font-style: italic">
                      Este insumo ya existe en la lista:
                      {{ item.option.nombreInsumo }}
                    </div>
                  </mat-option>
                </mat-autocomplete>
              </mat-form-field>
            </div>
            <div class="col-sm-4 w-100">
              <mat-label class="label">Cantidad de Insumo a Retirar</mat-label>
              <mat-form-field appearance="outline" class="w-100 hide-hint">
                <input
                  matInput
                  placeholder="Cantidad de Insumo a Retirar"
                  formControlName="cantidad"
                  name="cantidad"
                  type="number"
                  min="0"
                  [step]="
                    inputInsumoControl.value?.unidadMedida === 'kg' ? 0.01 : 1
                  "
                />
              </mat-form-field>
            </div>
            <div class="col-sm-4 w-100">
              <mat-label class="label">Unidad de Medida</mat-label>
              <mat-form-field appearance="outline" class="w-100 hide-hint">
                <input
                  matInput
                  placeholder="Unidad de Medida"
                  formControlName="unidadMedida"
                  name="unidad de medida"
                  readonly
                />
              </mat-form-field>
            </div>
          </div>

          <button
            mat-raised-button
            color="primary"
            (click)="addFoodItemToTheFileAsAdditionalFoodItem()"
            [disabled]="!newInsumoForm.valid"
          >
            Añadir Insumo
          </button>
        </div>
      </div>
    </form>

    <div class="row-base gap-20" style="width: 100%">
      <div class="col-sm-4 w-100">
        <mat-form-field appearance="outline" class="w-100 hide-hint">
          <mat-label>Categoría</mat-label>
          <mat-select
            [(value)]="selectedCategoria"
            (selectionChange)="applyFilterSelect()"
          >
            <mat-option [value]="null">Todas las categorías</mat-option>
            <mat-option
              *ngFor="let categoria of availableCategories"
              [value]="categoria"
            >
              {{ categoria }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col-sm-4 w-100">
        <mat-form-field appearance="outline" class="w-100 hide-hint">
          <input
            matInput
            placeholder="Buscar Insumos/Egresos..."
            (keyup)="applyFilter($event)"
          />
          <mat-icon matSuffix>
            <i-tabler name="search" class="icon-20"></i-tabler>
          </mat-icon>
        </mat-form-field>
      </div>
    </div>
    <div style="width: 100%">
      <div
        style="
          font-size: 12px;
          color: #666;
          background-color: #f5f5f5;
          padding: 8px 12px;
          border-radius: 4px;
          margin-bottom: 15px;
          border-left: 3px solid #2196f3;
        "
      >
        <strong>Nota:</strong> La cantidad por defecto es el acumulado de
        insumos repetidos por menú
      </div>
      <div class="table-responsive">
        <table
          mat-table
          [dataSource]="dataSource"
          matSort
          class="no-wrap m-t-0 v-middle w-100"
        >
          <ng-container matColumnDef="Check">
            <th
              class="f-w-600 c-s-15 custom-column"
              mat-header-cell
              *matHeaderCellDef
            >
              <mat-checkbox
                color="primary"
                (change)="$event ? toggleAllRows() : null"
                [checked]="isAllSelected()"
              >
              </mat-checkbox>
            </th>
            <td
              class="f-s-14 custom-column"
              mat-cell
              *matCellDef="let foodItemOutflow"
            >
              <mat-checkbox
                color="primary"
                [checked]="foodItemOutflow.checked"
                (change)="updateCheck(foodItemOutflow)"
              >
              </mat-checkbox>
            </td>
          </ng-container>

          <ng-container matColumnDef="codigoInsumo">
            <th
              class="f-w-600 f-s-15 custom-column"
              mat-header-cell
              mat-sort-header
              *matHeaderCellDef
            >
              Categoria
            </th>
            <td class="f-s-14 custom-column" mat-cell *matCellDef="let element">
              {{
                element?.codigoInsumo ||
                  'Este Insumo ya no Existe en el Sistema'
              }}
            </td>
          </ng-container>

          <ng-container matColumnDef="nombreInsumo">
            <th
              class="f-w-600 f-s-15 custom-column"
              mat-header-cell
              mat-sort-header
              *matHeaderCellDef
            >
              Insumo
            </th>
            <td class="f-s-14 custom-column" mat-cell *matCellDef="let element">
              {{ element?.nombreInsumo }}
            </td>
          </ng-container>

          <ng-container matColumnDef="cantidad">
            <th
              class="f-w-600 f-s-15 custom-column"
              mat-header-cell
              mat-sort-header
              *matHeaderCellDef
            >
              Cantidad x Menú
            </th>
            <td class="f-s-14 custom-column" mat-cell *matCellDef="let element">
              {{ element?.cantidad | number: '1.2-2' }}
            </td>
          </ng-container>

          <ng-container matColumnDef="totalMenuCount">
            <th
              class="f-w-600 f-s-15 custom-column"
              mat-header-cell
              mat-sort-header
              *matHeaderCellDef
            >
              Total Menús
            </th>
            <td class="f-s-14 custom-column" mat-cell *matCellDef="let element">
              {{ totalMenuCount | toFixed: 1:'up' }}
            </td>
          </ng-container>
          <ng-container matColumnDef="cantidadTotal">
            <th
              class="f-w-600 f-s-15 custom-column"
              mat-header-cell
              mat-sort-header
              *matHeaderCellDef
            >
              Cantidad Total Retirado
            </th>
            <td
              class="f-s-14 custom-column"
              mat-cell
              *matCellDef="let insumo; let i = index"
            >
              <div
                style="
                  display: flex;
                  gap: 10px;
                  align-items: center;
                  justify-content: center;
                "
              >
                <div *ngIf="activeTextArea !== insumo.id" style="max-width: 80%">
                  {{ insumo?.cantidadTotal | number: '1.2-2' }}
                </div>
                <ng-container *ngIf="insumo?.checked && isConfirmedOutflow(insumo)">
                  <a
                    *ngIf="activeTextArea !== insumo.id"
                    (click)="
                      setActiveTextArea(insumo); $event.stopPropagation()
                    "
                    class="icon-Active"
                  >
                    <i-tabler name="pencil" class="icon-20"></i-tabler>
                  </a>

                  <mat-form-field
                    appearance="outline"
                    class=""
                    *ngIf="activeTextArea === insumo.id"
                    style="max-width: 120px"
                  >
                    <input
                      (click)="$event.stopPropagation()"
                      [(ngModel)]="totalQuantityToRemove"
                      matInput
                      min="0"
                      step="0.01"
                      type="number"
                    />
                  </mat-form-field>

                  <a
                    *ngIf="activeTextArea === insumo.id"
                    (click)="
                      updateFoodOutflowTotalQuantityToRemove(insumo);
                      $event.stopPropagation()
                    "
                    class="icon-Active"
                  >
                    <i-tabler name="check" class="icon-20"></i-tabler>
                  </a>
                </ng-container>
              </div>
            </td>
          </ng-container>

          <ng-container matColumnDef="unidadMedida">
            <th
              class="f-w-600 f-s-15 custom-column"
              mat-header-cell
              mat-sort-header
              *matHeaderCellDef
            >
              Unidad de Medida
            </th>
            <td
              class="f-s-14 custom-column"
              mat-cell
              *matCellDef="let foodItemOutflow"
            >
              {{ foodItemOutflow?.unidadMedida || '-' }}
            </td>
          </ng-container>

          <ng-container matColumnDef="observation">
            <th
              class="f-w-600 f-s-15 custom-column"
              mat-header-cell
              mat-sort-header
              *matHeaderCellDef
            >
              Observación
            </th>
            <td
              class="f-s-14 custom-column"
              mat-cell
              *matCellDef="let foodItemOutflow"
            >
              <div
                style="
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  gap: 4px;
                  width: 100%;
                "
              >
                {{ foodItemOutflow?.observation || '-' }}
                <div
                  *ngIf="foodItemOutflow?.checked"
                  (click)="openDialogEditObservation(foodItemOutflow)"
                  class="icon-Active"
                  style="cursor: pointer"
                >
                  <i-tabler name="pencil" class="icon-20"></i-tabler>
                </div>
              </div>
            </td>
          </ng-container>

          <ng-container matColumnDef="evidencia">
            <th
              class="f-w-600 f-s-15 custom-column"
              mat-header-cell
              *matHeaderCellDef
            >
              Evidencia de Retiro
            </th>
            <td
              class="f-s-14 custom-column"
              mat-cell
              *matCellDef="let insumo; let i = index"
            >
              <span *ngIf="!insumo?.checked">-</span>
              <button
                *ngIf="insumo?.checked"
                mat-icon-button
                (click)="openDialogUploadEvidence(insumo)"
              >
                <mat-icon
                  *ngIf="!insumo.hasDocument"
                  [ngClass]="insumo.hasDocument ? 'icon-green' : 'icon-color'"
                  [matTooltip]="'Subir evidencia de retiro'"
                >
                  upload
                </mat-icon>
                <mat-icon
                  *ngIf="insumo.hasDocument"
                  [ngClass]="insumo.hasDocument ? 'icon-green' : 'icon-color'"
                  [matTooltip]="'Ver o descargar evidencia de retiro'"
                >
                  <i-tabler class="icon-20"> download </i-tabler>
                </mat-icon>
              </button>
            </td>
          </ng-container>

          <tr
            mat-header-row
            *matHeaderRowDef="displayedColumns; sticky: true"
          ></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
      </div>
      <div
        *ngIf="dataSource.filteredData.length === 0"
        class="div-center vertical-center"
        style="
          font-weight: 500;
          font-size: 12px;
          line-height: 14.4px;
          letter-spacing: 0%;
          color: #808080;
          min-height: 236px;
        "
      >
        Tu lista de insumos está vacía. ¡Agrega uno y aparecerá aquí!
      </div>
      <div
        style="
          width: 100%;
          display: flex;
          justify-content: flex-end;
          align-items: center;
        "
      >
        <mat-paginator
          [pageSizeOptions]="[5, 10, 20]"
          showFirstLastButtons
        ></mat-paginator>
      </div>
    </div>
  </div>
</mat-dialog-content>

<div
  class="column-base gap-20 div-center"
  style="padding: 30px; text-align: center; min-height: fit-content"
  *ngIf="!isLoading"
>
  <div>
    Primero, selecciona los insumos necesarios. ¿Qué deseas hacer con ellos?
  </div>
  <div class="dialog-action-options row-base gap-20">
    <div class="dialog-action-option column-base gap-20 div-center">
      <div>Generar un PDF con los insumos seleccionados.</div>
      <button
        mat-raised-button
        color="primary"
        style="
          width: fit-content;
          border-radius: 4px;
          box-shadow: none;
          font-size: 12px;
        "
        (click)="generarPDF()"
        [disabled]="!isAnySelected()"
      >
        <div
          *ngIf="isLoadingGenerarPdf"
          style="width: 100%; cursor: not-allowed"
          class="row-base center-div vertical-center white-spinner gap-8"
        >
          Generando
          <mat-spinner [diameter]="20" class="white-spinner"></mat-spinner>
        </div>
        <div *ngIf="!isLoadingGenerarPdf">Generar PDF</div>
      </button>
    </div>
    <div class="dialog-action-option column-base gap-20 div-center">
      <div>Registrar los insumos en la tabla.</div>
      <button
        mat-raised-button
        color="primary"
        style="
          width: fit-content;
          border-radius: 4px;
          box-shadow: none;
          font-size: 12px;
        "
        [disabled]="!hasPendingChanges()"
        (click)="updateOutflows()"
      >
        <div
          *ngIf="loadingConfirmarInsumos"
          style="width: 100%; cursor: not-allowed"
          class="row-base center-div vertical-center white-spinner gap-8"
        >
          Confirmando
          <mat-spinner [diameter]="20" class="white-spinner"></mat-spinner>
        </div>
        <div *ngIf="!loadingConfirmarInsumos">Confirmar Insumos</div>
      </button>
    </div>
  </div>
</div>
